import { render, staticRenderFns } from "./DICOMView.vue?vue&type=template&id=5e9c436c"
import script from "./DICOMView.vue?vue&type=script&lang=js"
export * from "./DICOMView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports